import React from 'react';
import styled from 'styled-components';

const MarkdownRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  white-space: pre-wrap;
  word-break: break-word;

  p {
    margin: 0;
    line-height: inherit;
  }

  ul {
    margin: 0;
    padding-left: 20px;
    list-style-type: disc;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  li {
    margin: 0;
    line-height: inherit;
  }

  strong {
    font-weight: 600;
  }
`;

const renderInline = text => {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length >= 5) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
};

const MarkdownText = ({ children }) => {
  const text = typeof children === 'string' ? children : '';
  if (!text) return null;

  const lines = text.split('\n');
  const blocks = [];
  let paragraph = [];
  let list = null;

  const flushParagraph = () => {
    if (paragraph.length) {
      blocks.push({ type: 'p', lines: paragraph });
      paragraph = [];
    }
  };

  const flushList = () => {
    if (list) {
      blocks.push({ type: 'ul', items: list });
      list = null;
    }
  };

  lines.forEach(line => {
    if (line.startsWith('- ')) {
      flushParagraph();
      if (!list) list = [];
      list.push(line.slice(2));
    } else if (line.trim() === '') {
      flushParagraph();
      flushList();
    } else {
      flushList();
      paragraph.push(line);
    }
  });
  flushParagraph();
  flushList();

  return (
    <MarkdownRoot>
      {blocks.map((block, i) => {
        if (block.type === 'p') {
          return (
            <p key={i}>
              {block.lines.map((line, li) => (
                <React.Fragment key={li}>
                  {renderInline(line)}
                  {li < block.lines.length - 1 && <br />}
                </React.Fragment>
              ))}
            </p>
          );
        }
        return (
          <ul key={i}>
            {block.items.map((item, ii) => (
              <li key={ii}>{renderInline(item)}</li>
            ))}
          </ul>
        );
      })}
    </MarkdownRoot>
  );
};

export default MarkdownText;
